/** Spanish UI strings added to Progreso Académico by FASE 1 (Matrícula por curso, 2026-09-30). */
/** Mensajes sugeridos para WhatsApp (se abren escritos en WappChat, sin enviar). {nombre}, {curso}, {horario}, {plantel}. */
export const WA_SUGERIDOS: { key: string; name: string; text: string }[] = [
	{ key: "retencion", name: "Retención", text: "Hola {nombre}, te hemos extrañado en {curso} ({horario}). ¿Todo bien? Cuéntanos si necesitas apoyo para seguir con tus clases en {plantel}." },
	{ key: "encuesta", name: "Encuesta", text: "Hola {nombre}, en Washington Academy queremos escucharte. ¿Nos regalas dos minutos para contarnos cómo va tu experiencia en {curso}?" },
	{ key: "pago", name: "Recordatorio de Pago", text: "Hola {nombre}, te recordamos que tienes una mensualidad pendiente de {curso}. Puedes pasar a caja en {plantel} o escribirnos por aquí para ayudarte." },
	{ key: "graduacion", name: "Por Graduarse", text: "¡Felicidades {nombre}! Estás por terminar {curso}. Pronto te contactaremos con los detalles de tu graduación en {plantel}." }
];

const S = {
	/* Chips de alerta con nombre propio (R2, 2026-10-22). */
	chipAll: "Todas",
	chipRotating: "Rotativos",
	chipComposite: "Compuestos",
	chipAbsent: "2+ Semanas Sin Asistir",
	chipAbsentWeek: "Faltó Últimos 7 Días",
	chipGraduating: "Por Graduarse",
	chipBelowMinimum: "Bajo el Mínimo",
	chipBlockNoNext: "Bloque Sin Siguiente",
	chipOverHours: "Horas de Más",
	chipCompleted: "Horas Completas",
	includeInactiveSchedules: "Incluir Horarios No Activos",
	includeInactiveStudents: "Incluir Alumnas No Activas",

	/* Filtros por id (selección múltiple). */
	mentor: "Maestra",
	course: "Curso",
	period: "Periodo",
	schedules: "Horarios",
	allMentors: "Todas las Maestras",
	allCourses: "Todos los Cursos",
	allPeriods: "Todos los Periodos",
	all: "Todos",
	chosen: (n: number) => `${n} ${n === 1 ? "elegido" : "elegidos"}`,
	chosenF: (n: number) => `${n} ${n === 1 ? "elegida" : "elegidas"}`,
	noSchedules: "Sin horarios",
	noMatches: "Sin resultados",
	pickToSeeSchedules: "Elige un curso o una maestra para ver sus horarios.",
	clear: "Limpiar",
	searchOptions: "Buscar",
	searchPlaceholder: "Buscar alumna, correlativo o curso",
	clearSearch: "Limpiar búsqueda",
	export: "Exportar",
	emptyRows: "Sin alumnas con ese filtro.",

	/* Encabezado y conteos. */
	students: (n: number) => `${n} ${n === 1 ? "alumna" : "alumnas"}`,
	activeStudents: (n: number) => `${n} ${n === 1 ? "alumna activa" : "alumnas activas"}`,
	enrollments: (n: number) => `${n} ${n === 1 ? "matrícula" : "matrículas"}`,
	rotating: (n: number) => `${n} ${n === 1 ? "rotativo" : "rotativos"}`,
	composite: (n: number) => `${n} ${n === 1 ? "compuesto" : "compuestos"}`,
	withAlert: (n: number) => `${n} con alerta`,
	graduating: (n: number) => `${n} por graduarse`,

	/* Columnas. */
	colStudent: "Alumna",
	colCourse: "Curso",
	colSchedule: "Horario",
	colType: "Tipo",
	colHours: "Horas",
	colSessions: "Sesiones",
	colAttendance: "Asistencia",
	colAlert: "Alerta",
	colGrade: "Calificación",
	colActions: "Acciones",
	upToDate: "Al día",
	never: "Nunca",
	thisWeek: "Esta semana",
	weeksAbsent: (n: number) => `${n} ${n === 1 ? "semana sin ir" : "semanas sin ir"}`,

	/* Calificación (R2). */
	gradeNA: "N/D",
	gradeApproved: "Aprobado",
	gradeAtRisk: "En Riesgo",
	gradeNoGrades: "Sin Notas",
	gradesTitle: "Calificaciones",
	gradesLoading: "Cargando calificaciones…",
	gradesError: "No se pudieron cargar las calificaciones.",
	gradesFinal: "Nota Final",
	gradesMin: "Mínimo",
	gradesWeight: "Peso",
	gradesAvg: "Promedio",
	gradesItem: "Evaluación",
	gradesDate: "Fecha",
	gradesScore: "Nota",
	gradesNoItems: "Sin evaluaciones",

	/* Acciones por fila y a varias. */
	attendances: "Asistencias",
	profile: "Ficha de la Alumna",
	whatsapp: "WhatsApp",
	whatsappMany: (n: number) => `WhatsApp a ${n}`,
	selectedStudents: (n: number) => `${n} ${n === 1 ? "alumna elegida" : "alumnas elegidas"}`,
	clearSelection: "Quitar Selección",
	selectAllPage: "Elegir todas las de la página",
	selectRow: "Elegir para WhatsApp",
	attendancesLoading: "Cargando asistencias…",
	noData: "Sin datos.",
	noClasses: "Sin clases en este horario.",
	pagePrev: "Página anterior",
	pageNext: "Página siguiente",

	belowMinimumChip: "Bajo el Mínimo",
	/** "Bajo mínimo · repone 3" */
	belowMinimum: "Bajo mínimo",
	recovers: "repone",
	minimum: "mín.",
	/** "Transferida de <horario> · <fecha>" */
	transferredFrom: "Transferida de",
	otherSchedule: "otro horario",
	noneRequiredYet: "Sin clases exigidas",
	/** "2 repuestas" */
	recovered: (n: number) => `${n} ${n === 1 ? "repuesta" : "repuestas"}`,

	/* Pestañas y Por reponer (FASE 3). */
	tabProgress: "Progreso",
	tabRecoveries: "Por Reponer",
	recOpen: "Abiertas",
	recStatus: { 0: "Por Reponer", 1: "Programada", 2: "Repuesta", 3: "Exonerada" } as { [k: number]: string },
	recSearch: "Buscar alumna o curso",
	recAllCourses: "Todos los Cursos",
	recPage: (p: number, last: number, total: number) => `Página ${p} de ${last} · ${total}`,
	recLoading: "Cargando…",
	recEmpty: "Sin sesiones con ese filtro.",
	recClose: "Cerrar",
	recBack: "Volver",
	recColStudent: "Alumna",
	recColCourse: "Curso",
	recColSession: "Sesión",
	recColStatus: "Estado",
	recColRecovery: "Reposición",
	recColCharge: "Cobro",
	recColNote: "Nota",
	recSession: "Sesión",
	recSchedule: "Programar",
	recReschedule: "Reprogramar",
	recMarkRecovered: "Marcar Repuesta",
	recWaive: "Exonerar",
	recScheduleField: "Horario",
	recDate: "Fecha",
	recTime: "Hora",
	recClassroom: "Aula",
	recMentor: "Maestra",
	recFromSchedule: "La del horario",
	recCharge: "Se cobra",
	recPrice: "Precio",
	recNote: "Nota",
	recPaid: "Pagado",
	recUnpaid: "Por pagar",
	recNoCharge: "Sin precio",
	recScheduledOk: "Reposición programada",
	recRecoveredOk: "Sesión repuesta",
	recWaivedOk: "Sesión exonerada"
};

export default S;
